import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SamplePage from './Pages/SamplePage';
import Error404 from './Pages/404';
import Login from './Auth/Login';
import Register from './Auth/Register';
import ForgotPasswordPage from './Auth/ForgotPassword';
import AccountSettings from './Auth/account_settings/AccountSettings';
import CountryList from './Pages/country_microservice/Country';
import CashPickUpList from './Pages/cashPickUp_microservice/CashPickUp';
import MFSMicroserviceList from './Pages/mfs_microservice/MFSMicroserviceList';
import Bank from './Pages/bank_microservice/bank/Bank';
import Branch from './Pages/bank_microservice/branch/Branch';
import BankBeneficiary from './Pages/bank_beneficiary/BankBeneficiary';
import Document from './Pages/kyc/document/Document';

import { AuthContext } from '../@jumbo/components/context/AuthContext';

import MFSBeneficiary from './Pages/MFS Beneficiary/MFSBeneficiary';
import CountryMFSMapper from './Pages/country_mfs_mapper/CountryMFSMapper';
import CountryBankMapper from './Pages/country_bank_mapper/CountryBankMapper';
import Question from './Pages/faq/question/Question';
import Dashboard from './Dashboards/Listing/index';
import Category from './Pages/faq/category/Category';
import Test from './Pages/Test';
import TierList from './Pages/tier/tierList/TierList';
import RequirementsList from './Pages/tier/requiremetns/RequirementsList';
import Agent from './Pages/agent/Agent';
import AgentRequest from './Pages/agent/AgentRequest';
import BaseCurrencyConversion from './Pages/currency/BaseCurrencyConversion';
import CreateCurrencyConversionRate from './Pages/currency/CreateCurrencyConversionRate';
import DocumentsCreate from './Pages/country_documents/DocumentsCreate';
import AllBaseCurrency from './Pages/currency/AllBaseCurrency';
import KycList from './Pages/kyc/document/KycList';
import TierRequest from './Pages/tier/TierRequest';
import TransactionChargePolicy from './Pages/transaction/TransactionChargePolicy';
import TransactionMethod from './Pages/transaction/TransactionMethod';
import Transfers from './Pages/transaction/Transfers';
import DocumentsList from './Pages/country_documents/DocumentsList';
import MethodOption from './Pages/transaction/MethodOption';
import LimitList from './Pages/tier/limitList/LimitList';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { glob_pay_admin_auth } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={props =>
        glob_pay_admin_auth.access_token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const Routes = () => {
  const { glob_pay_admin_auth } = useContext(AuthContext);
  const location = useLocation();
  // console.log('glob_pay_admin_auth', glob_pay_admin_auth);

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={'/dashboard'} />;
  } else if (glob_pay_admin_auth.access_token && location.pathname === '/signin') {
    return <Redirect to={'/dashboard'} />;
  }

  return (
    <React.Fragment>
      <Switch>
        <RestrictedRoute exact path="/dashboard" component={Dashboard} />
        <RestrictedRoute exact path="/account-settings" component={AccountSettings} />
        <RestrictedRoute exact path="/country-list" component={CountryList} />
        <RestrictedRoute exact path="/cash-pickup-list" component={CashPickUpList} />
        <RestrictedRoute exact path="/mfs-list" component={MFSMicroserviceList} />
        <RestrictedRoute exact path="/mfs-beneficiary-list" component={MFSBeneficiary} />
        <RestrictedRoute exact path="/bank-list" component={Bank} />
        <RestrictedRoute exact path="/branch" component={Branch} />
        <RestrictedRoute exact path="/bank-beneficiary-list" component={BankBeneficiary} />
        <RestrictedRoute exact path="/country-mfs-mapper-list" component={CountryMFSMapper} />
        <RestrictedRoute exact path="/country-bank-mapper-list" component={CountryBankMapper} />
        <RestrictedRoute exact path="/question" component={Question} />
        <RestrictedRoute exact path="/category" component={Category} />

        {/* kyc  */}
        <RestrictedRoute exact path="/document" component={Document} />
        <RestrictedRoute exact path="/kyc-list" component={KycList} />

        {/* tier  */}
        <RestrictedRoute exact path="/tier" component={TierList} />
        <RestrictedRoute exact path="/requirements" component={RequirementsList} />
        <RestrictedRoute exact path="/tier-request-upgrade" component={TierRequest} />
        <RestrictedRoute exact path="/limit" component={LimitList} />

        {/* transaction  */}
        <RestrictedRoute exact path="/admin/transfers" component={Transfers} />
        <RestrictedRoute exact path="/transaction-charge-policy" component={TransactionChargePolicy} />
        <RestrictedRoute exact path="/transaction-method" component={TransactionMethod} />
        <RestrictedRoute exact path="/method-option" component={MethodOption} />

        <RestrictedRoute exact path="/agent" component={Agent} />
        <RestrictedRoute exact path="/agent-request" component={AgentRequest} />

        {/* currency  */}
        <RestrictedRoute exact path="/base-currency-conversion-rate" component={BaseCurrencyConversion} />
        <RestrictedRoute exact path="/all-base-currency" component={AllBaseCurrency} />
        <RestrictedRoute exact path="/create-currency-conversion-rate" component={CreateCurrencyConversionRate} />

        {/* country documents  */}
        <RestrictedRoute exact path="/country-documents-create" component={DocumentsCreate} />
        <RestrictedRoute exact path="/country-documents" component={DocumentsList} />

        <RestrictedRoute exact path="/sample-page" component={SamplePage} />
        <Route path="/signin" component={Login} />
        <RestrictedRoute exact path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route path="/test" component={Test} />

        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
